import { Food } from "@/components/nutrition/foodColumns";
import { Meal } from "@/components/nutrition/mealColumns";

export const MEAL_IMAGE_BUCKET = "meal-images";
export const MEAL_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

export const buildMealImagePath = (orgId: string, mealId: string) =>
  `${orgId}/meals/${mealId}_${Date.now()}`;

export const calculateFieldWithServing = (
  food: Food,
  property: keyof Food
): number => {
  const field = food[property];
  if (typeof field !== "number") {
    console.warn(
      `calculateFieldWithServing, ${property} type ${typeof property} is not number}`
    );
    return 0;
  }
  if (food.serving_size === undefined) {
    return 0;
  }

  const value = field * (food.serving_size / food.default_serving_size);

  return +value.toFixed(2);
};

export const calculateTotalFieldWithServing = (
  foods: Food[],
  property: keyof Food
): number => {
  if (!foods.length) {
    return 0;
  }

  const field = foods[0][property];
  if (typeof field !== "number") {
    console.warn(
      `calculateFieldWithServing, ${property} type ${typeof property} is not number}`
    );
    return 0;
  }

  const value = foods.reduce(
    (a, b) =>
      a +
      +(b[property] ?? 0) *
        ((b.serving_size ?? 0) / (b.default_serving_size ?? 1)),
    0
  );

  return +Math.round(value);
};

export const FoodsFieldTotal = (field: keyof Food, meals: Meal[]) =>
  meals.reduce(
    (n, { foods }) => n + calculateTotalFieldWithServing(foods, field),
    0
  );
